<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101317"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.appraisalCategory.serialNumber')">
            <el-input-number v-model="editDialog.form.serialNo" no="serialNumber" style="width: 150px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.appraisalCategory.code')">
            <el-input v-model="editDialog.form.code" no="code" style="width: 150px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.appraisalCategory.chineseName')">
            <el-input v-model="editDialog.form.chineseName" no="chineseName" style="width: 150px" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.appraisalCategory.englishName')">
            <el-input v-model="editDialog.form.englishName" no="englishName" style="width: 150px" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { delAppraisalCategory, getAppraisalCategoryList, saveAppraisalCategory } from '@/api/basicData/appraisalCategory'

export default {
  name: 'AppraisalCategory',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.appraisalCategory.serialNumber'),
          field: 'serialNo',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.appraisalCategory.code'),
          field: 'code',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.appraisalCategory.chineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.appraisalCategory.englishName'),
          field: 'englishName',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNo: '',
          code: '',
          chineseName: '',
          englishName: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getAppraisalCategoryList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          serialNo: '',
          code: '',
          chineseName: '',
          englishName: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('Information.AppraisalCategory')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('Information.AppraisalCategory')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (form.serialNo === null || form.serialNo === '') {
        self.$message.warning(self.$t('baseInfo.basicData.appraisalCategory.serialNumberCheck'))
        return
      }
      if (form.code === null || form.code === '') {
        self.$message.warning(self.$t('baseInfo.basicData.appraisalCategory.codeCheck'))
        return
      }
      if (form.chineseName === null || form.chineseName === '') {
        self.$message.warning(self.$t('baseInfo.basicData.appraisalCategory.chineseNameCheck'))
        return
      }
      if (form.englishName === null || form.englishName === '') {
        self.$message.warning(self.$t('baseInfo.basicData.appraisalCategory.englishNameCheck'))
        return
      }
      const loading = getLoading()
      saveAppraisalCategory(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        if (res.data && Number(res.data) > 0) {
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        } else {
          self.editDialog.visible = false
        }
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows)
      }).catch(() => { })
    },
    syncRemove(rows) {
      const self = this
      const loading = getLoading()
      const uuids = Array.from(rows, p => p.uuid)
      delAppraisalCategory(uuids).then(res => {
        if (res.data && Number(res.data) > 0) {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        }
      }).catch(() => { }).finally(() => loading.close())
    }
  }
}
</script>
